import { Component, inject } from '@angular/core';
import { RegisterTypeService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  RegisterTypeCreateDto,
  RegisterTypeDto,
  RegisterTypeExcelDownloadDto,
  RegisterTypeUpdateDto,
} from '../proxy/planning/dtos/register-type';
import { REGISTERTYPE_CONFIG, REGISTERTYPE_FIELDS } from './register-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-register-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, RegisterTypeService, ConfirmationService],
  templateUrl: './register-type.html',
  styleUrl: './register-type.scss',
})
export class RegisterType extends BaseCrudComponent<
  RegisterTypeDto,
  RegisterTypeCreateDto,
  RegisterTypeUpdateDto,
  RegisterTypeExcelDownloadDto
> {
  service = inject(RegisterTypeService);
  config = REGISTERTYPE_CONFIG;
  fields = REGISTERTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: RegisterTypeDto): RegisterTypeUpdateDto {
    return {
      code: data.code,
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'RegisterType';
  }
}
